import React from 'react';
import Billing from './billing/index';

const BillingPage = () => {
  return <Billing />;
};

export default BillingPage;
